/*! Copyright 2025 Lane Crawford, All Rights Reserved. */

/**
 *
 * [ module ]
 * register -> createAccount
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.register = LC.register || {};

	/**
	 *
	 * checkout.shipping.details
	 * the main javascript module for shipping/collection details
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */

	new lcmodule2( "register.createAccount", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

			_this.siteId = LC.config.getValue( "site.siteID" );
			_this.interactedWithCountry = false;
			_this.preloadTimer = null;

		};

		/**
		 * initialise the createAccount module
		 */

		ex.init = function() {

			_this.$countryWrapper = 	$( ".PiplResidentWrapper" );

			_this.$form = $("#socialLoginStyleCreateAccountForm");
			_this.$fieldsWrapper = $(".register-form__content");

			_this.$country = 			_this.$fieldsWrapper.find( ".pipl__resident" );
			_this.$phonePrefix = 		_this.$fieldsWrapper.find( "#RegisterFormPhonePrefix" );
			_this.$marketingCheckbox =  _this.$fieldsWrapper.find(".js-checkbox-signup-consent");
			_this.$btnSubmit = 			_this.$fieldsWrapper.find(".register-form__submit");
			_this.$emailField = 		$( "#RegisterFormEmail" );



			_this.successUrl = "/account/accountDetails.jsp?created=1";

			_this.siteId = LC.config.getValue( "site.siteID" );
			_this.isHkSite = _this.siteId === "zh_HK";

			_this.emailErrorData = {
				form: "#socialLoginStyleCreateAccountForm",
				response: {
					errorList: [
						{ errorCode: "email", errorMessage: "Please input Email" }
					],
					errorMessage: "Some of the information is missing or has errors. " +
									"<br/>Please review the highlighted fields below.<br/>",
					showGeneralErrorMessage: true
				}
			};


		};

		_this.populateHiddenFields = function() {

			var $form = _this.$form,
				$fields = _this.$fieldsWrapper,
				values = {};

			if ( $form.length ) {

				/**
				 * we need to populate the hidden fields.
				 * the ones below need to be handled by Javascript as they are inside
				 * of jsp file-includes. Some fields, however, are in the register-form.jsp file
				 * and can be handled by submitting the form.
				 */
				values.salutation = $fields.find("#RegisterFormSalutation").val();
				values.firstName = $fields.find("#RegisterFormFirstName").val();
				values.lastName = $fields.find("#RegisterFormLastName").val();
				values.email = $fields.find("#RegisterFormEmail").val();
				values.phonePrefix = $fields.find("#RegisterFormPhonePrefix").val();
				values.phoneNumber = $fields.find("#RegisterFormPhone").val();

				values.password = $fields.find("#RegisterFormPassword").val();
				values.confirmPassword = $fields.find("#RegisterFormConfirmPassword").val();



				values.country = $fields.find(".pipl__resident").val();
				values.state = $fields.find("#RegisterFormState").val();
				values.district = $fields.find("#RegisterFormDistrict").val();
				values.piplPersonal = $fields.find( "input[name='pipl_personal']" ).is( ":checked" );
				values.piplSensitive = $fields.find( "input[name='pipl_sensitive']" ).is( ":checked" );
				values.piplXborder = $fields.find( "input[name='pipl_xborder']" ).is( ":checked" );


				$form.find(".registerFormSalutation").val( values.salutation );
				$form.find(".registerFormFirstName").val( values.firstName );
				$form.find(".registerFormLastName").val( values.lastName );
				$form.find(".registerFormLogin").val( values.email );
				$form.find(".registerFormPhonePrefix").val( values.phonePrefix );
				$form.find(".registerFormPhone").val( values.phoneNumber );

				$form.find(".registerFormPassword").val( values.password );
				$form.find(".registerFormConfirmPassword").val( values.confirmPassword );

				$form.find(".registerFormCountry").val( values.country );
				$form.find(".registerFormState").val( values.state );
				$form.find(".registerFormDistrict").val( values.district );
				$form.find(".registerFormPiplPersonal").val( values.piplPersonal );
				$form.find(".registerFormPiplSensitive").val( values.piplSensitive );
				$form.find(".registerFormPiplXborder").val( values.piplXborder );

			}

			// make sure consent for marketing has been properly applied
			LC.pubsub.trigger("registration.setConsent", [ _this.$form ] );

		};

		_this.disableSubmit = function() {

			// we wait a short amount of time, as it's
			// not nice for the user to see flashing preloaders
			// if the response is very fast.
			_this.preloadTimer = setTimeout( function() {
				LC.pubsub.trigger("preloader.open");
			}, 300 );

			_this.$btnSubmit.prop("disabled", true );

		};

		_this.enableSubmit = function() {

			clearTimeout( _this.preloadTimer );
			LC.pubsub.trigger("preloader.close");
			_this.$btnSubmit.prop("disabled", false );

		};

		ex.sendForm = function(ev) {

			var ajaxUrl = _this.$form.attr("action");

			if (ev) {
				ev.preventDefault();
			}

			if ( ajaxUrl ) {

				_this.disableSubmit();
				_this.populateHiddenFields();

				_this.ajax = $.ajax({

					url: _this.postUrl,
					type: "POST",
					data: _this.$form.serialize(),
					dataType: "json"

				})

					.done( _this.submitSuccess )
					.always( _this.enableSubmit );

			}

		};

		/**
		 * handling for the successful response from
		 * the server after submitting the form
		 *
		 * @param  { Object } response | ATG Form Submit Response
		 */
		_this.submitSuccess = function( response ) {

			var success,
				errorData;

			// was the form submission really a success?
			success = response && (response.isProcessSuccess);

			if ( success ) {

				// trigger success,
				// used for things such as hotjar form submission
				LC.pubsub.trigger("forms.success", response );

				_this.registerSuccess( response );

			} else {

				// data to pass for the form triggers.
				errorData = {
					form: "#socialLoginStyleCreateAccountForm",
					response: response
				};

				// trigger errors,
				// check if we need to verify account,
				// check if the user's account already exists
				LC.pubsub.trigger("forms.showErrors", errorData );
				LC.pubsub.trigger("forms.verifyCheck", errorData );
				LC.pubsub.trigger("forms.existingCheck", errorData );

			}

		};

		_this.emptyEmailHandling = function() {

			LC.pubsub.trigger("forms.showErrors", _this.emailErrorData );
			LC.pubsub.trigger("forms.verifyCheck", _this.emailErrorData );
			LC.pubsub.trigger("forms.existingCheck", _this.emailErrorData );

		};


		/**
		 * handling for submitting the registration form,
		 * or showing an email prompt.
		 */
		ex.submitForm = function() {

			var emailValue = _this.$emailField.val(),
				cnResident = _this.$phonePrefix.val() === "86";

			if ( _this.isHkSite && !cnResident && emailValue === "" ) {

				_this.emptyEmailHandling();
				return false;

			}

			ex.sendForm();

			LC.track.trigger("ga.event", {
				category: "Registration Form",
				action: "Submit",
				label: "Send Register Form"
			});

			return false;

		};

		_this.registerSuccess = function( response ) {

			// save the redirect url, it might be in the
			// atg response from the server.
			var redirect = response.ajaxSuccessRedirectUrl || _this.successUrl;

			// special ga4 sign_up event
			LC.track.trigger( "ga.event", {
				eventName: "sign_up",
				eventData: { method: "form" }
			});

			LC.track.trigger("ga.event", {
				category: "Registration Form",
				action: "Submit",
				label: "Successfully Register"
			});

			LC.pubsub.trigger("preloader.open");
			LC.location.href = redirect;

		};

		/**
		 * method to handle updating the phone prefix.
		 * 	- update the country
		 * 	- update the preset consent
		 */
		ex.changePhonePrefix = function() {

			if ( _this.siteId !== "en_US" ) {

				_this.updateCountryFromPrefix();
				_this.updateMarketing();

			}

		};

		ex.changeCountry = function() {

			_this.updateMarketing();
			LC.pubsub.trigger( "pipl.bindCountries" );

		};

		/**
		 * uncheck the consent box if customer is indicated as china resident,
		 * this only happens when switching to china, not when switching away.
		 */
		_this.updateMarketing = function() {

			var country = _this.$country.val();

			if ( country === "CN" ) {
				_this.$marketingCheckbox.prop( "checked", country !== "CN" );
			}

		};

		/**
		 * method to handle updating the country
		 * based on the phone prefix you've selected.
		 */
		_this.updateCountryFromPrefix = function() {

			var $country = _this.$country,
				$options = $country.find("option"),
				$prefix = _this.$fieldsWrapper.find( "#RegisterFormPhonePrefix" ),
				prefixValue = $prefix.val(),
				code;

			if ( !prefixValue ) {
				LC.warn( "updateCountry: invalid prefixValue" );
				return;
			}

			if ( _this.interactedWithCountry ) {
				return;
			}

			if ( _this.siteId !== "zh_CN" ) {

				switch ( prefixValue ) {

					case "1":
						code = "US"; // special handling so US is selected for code 1 (sorry, Canada)
						break;
					case "61":
						code = "AU"; // special handling so AU is selected for code 61
						break;
					case "44":
						code = "GB"; // special handling so GB is selected for code 44
						break;
					default:
						code = $options.filter( function( i, el ) {
							return el.dataset.prefix === prefixValue;
						}).data( "cc" );


				}

				if ( !code ) {
					LC.warn( "updateCountry: no matching countrycode", prefixValue );
					return;
				}

				$country.val( code );
				$country.trigger( "update" );
				ex.changeCountry();
				_this.$countryWrapper.removeClass( ex.hiddenClass );

			}

		};

		ex.events = function() {

			_this.$btnSubmit
				.off(".registerSubmit")
				.on("click.registerSubmit", function(e) {

					e.preventDefault();
					ex.submitForm();

				});

			_this.$phonePrefix
				.off( ".phonePrefix" )
				.on( "change.phonePrefix keyup.phonePrefix", ex.changePhonePrefix );

			_this.$country
				.off( ".country" )
				.on( "change.country", function() {

					_this.interactedWithCountry = true;
					ex.changeCountry();

				});

		};

		ex.subscribe = function() {

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=register.js
